import CameraIcon from '@/common/assets/icons/cameraIcon.svg?react';
import CloseIcon from '@/common/assets/icons/closeIconborderLess.svg?react';
import FlashIcon from '@/common/assets/icons/flashIcon.svg?react';
import FlashIsOnIcon from '@/common/assets/icons/flashIconIsOn.svg?react';
import TickIcon from '@/common/assets/icons/tick-circle.svg?react';
import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import CameraCustomMedia from '@/common/components/camera/components/CameraCustomMedia';
import CameraLoading from '@/common/components/camera/components/CameraLoading';
import useCamera from '@/common/components/camera/hooks/useCamera';
import useTakePhoto from '@/common/components/camera/hooks/useTakePhoto';
import { ImageType } from '@/common/components/imageGallery/components/Extensions/moreItemsExtension/moreItemsExtension.type';
import { useRef, useState } from 'react';
import { Box, Flex } from 'styled-system/jsx';

const CompletingImages = ({
  onDenyCamera,
  onCompleteImages,
  maxTotalImages,
  closeCamera,
  totalImagesCount,
}: {
  onDenyCamera?: () => void;
  onCompleteImages: (images: ImageType[]) => void;
  maxTotalImages: number;
  totalImagesCount?: number;
  closeCamera: () => void;
}) => {
  const photoRef = useRef<HTMLCanvasElement | null>(null);
  const [completeImages, setCompleteImages] = useState<ImageType[]>();
  const [totalImages, setTotalImages] = useState(totalImagesCount || 0);

  const {
    videoRef,
    disableCamera,
    setDisableCamera,
    handleClickLight,
    torchIsOn,
    stopStream,
    cameraStatus,
  } = useCamera({
    audio: true,
    onDenyCamera: () => onDenyCamera,
    rotate: true,
    closeCamera: closeCamera,
  });

  const { takePhoto } = useTakePhoto({
    photoRef,
    videoRef,
    rotate: true,
    onDenyCamera: () => onDenyCamera,
    hasSlider: false,
  });

  const afterTakePhoto = (images: { blob: Blob; url: string }) => {
    if (totalImages < maxTotalImages) {
      setDisableCamera(false);
      setCompleteImages((prev) => [
        ...(prev || []),
        {
          blob: images.blob,
          url: images.url,
        },
      ]);
      setTotalImages(totalImages + 1);
    }
  };

  const captureImage = () => {
    setDisableCamera(true);
    takePhoto({
      afterTakePhoto: (data) => {
        afterTakePhoto(data);
      },
    });
  };

  const onCloseCamera = () => {
    stopStream();
    setDisableCamera(false);
    setCompleteImages([]);
    setTotalImages(0);
    closeCamera();
  };

  const saveImages = () => {
    onCompleteImages(completeImages || []);
  };

  return (
    <>
      {cameraStatus === 'loading' ? <CameraLoading /> : null}

      <Flex
        flexDirection="column"
        display={cameraStatus === 'loading' ? 'none' : 'flex'}
      >
        <Flex
          zIndex="camera"
          position="fixed"
          left="0"
          top="0"
          width={window.innerWidth}
          backgroundColor="black-1"
          height={'100lvh'}
        >
          <CameraCustomMedia photoRef={photoRef} videoRef={videoRef} />
          <Box
            position="absolute"
            display="inline-block"
            transform="rotate(90deg)"
            padding="0.5rem 1rem"
            minW="300px"
            textAlign="center"
            left="-100px"
            top="50%"
            borderRadius="8px"
            backgroundColor="white"
          >
            <Flex align="center" justify="space-between">
              <Typography color="black-1">عکس های تکمیلی </Typography>
              <Typography color="black-1">{`${maxTotalImages} / ${totalImages}`}</Typography>
            </Flex>
          </Box>
        </Flex>
        <Flex
          zIndex="camera-layout"
          backgroundColor="black-4"
          height="10%"
          width="100%"
          margin="auto"
          maxWidth="maxContainer"
          minH="100px"
          position="fixed"
          bottom="0"
          left="0"
          right="0"
          borderRadius="24px 24px 0 0"
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex
            w="100%"
            mx={24}
            alignItems="center"
            justifyContent="space-between"
          >
            <Flex flex={1}>
              <Button
                variant="text"
                p={0}
                backgroundColor="transparent"
                onClick={onCloseCamera}
              >
                <CloseIcon />
              </Button>
            </Flex>
            <Flex flex={1.5} gap="3rem" alignItems="center">
              <Button
                backgroundColor="transparent"
                variant="text"
                p={0}
                onClick={() =>
                  disableCamera || totalImages === maxTotalImages
                    ? undefined
                    : captureImage()
                }
              >
                <CameraIcon
                  fill={
                    disableCamera || totalImages === maxTotalImages
                      ? '#c2c2c2'
                      : '#fff'
                  }
                />
              </Button>

              <Box onClick={() => handleClickLight()}>
                {torchIsOn ? <FlashIsOnIcon /> : <FlashIcon />}
              </Box>

              <Button
                variant="text"
                p={0}
                backgroundColor="transparent"
                onClick={saveImages}
                disabled={!completeImages?.length}
              >
                <TickIcon
                  stroke={!completeImages?.length ? '#c2c2c2' : '#7548F0'}
                />
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};
export default CompletingImages;
